export default __webpack_public_path__ + "static/media/ChangeCredit.08298434.svg";